class ExpresionesRegulares {
  constructor() {
    this.NOMBRES =
      /^(?=.{1,20}$)(('|-|\s|\.|\(|\)?)([A-Za-zÀ-ÿ0-9Ññ]('|-|\s|\.|\(|\))?)\1?)+$/;
    this.NOMBREAPLICACION =
      /^(?=.{1,60}$)(('|-|\s|\.|\(|\)?)([A-Za-zÀ-ÿ0-9Ññ]('|-|\s|\.|\(|\))?)\1?)+$/;
    this.NOMBREOPERACION =
      /^(?=.{1,20}$)(('|-|\s|\.|\(|\)?)([A-Za-zÀ-ÿ0-9Ññ]('|-|\s|\.|\(|\))?)\1?)+$/;
    this.NOMBREFUNCIONALIDAD =
      /^(?=.{1,30}$)(('|-|\s|\.|\(|\)?)([A-Za-zÀ-ÿ0-9Ññ]('|-|\s|\.|\(|\))?)\1?)+$/;
    this.NOMBREMODULO =
      /^(?=.{1,50}$)(('|-|\s|\.|\(|\)?)([A-Za-zÀ-ÿ0-9Ññ]('|-|\s|\.|\(|\))?)\1?)+$/;
    this.DESCRIPTION =
      /^(?=.{1,20}$)(('|-|\s|\.|\(|\)?)([A-Za-zÀ-ÿ0-9Ññ]('|-|\s|\.|\(|\))?)\1?)+$/;
    this.DESCRIPTIONS =
      /^(?=.{1,255}$)(('|-|\s|\.|\(|\)?)([A-Za-zÀ-ÿ0-9Ññ]('|-|\s|\.|\(|\))?)\1?)+$/;
    this.APELLIDO =
      /^(?=.{1,30}$)(('|-|\s|\.|\(|\)?)([A-zÑñ]('|-|\s|\.|\(|\))?)\1?)+$/;
    this.CORREO =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.TELOTROS =
      /(^[1-9]((?!000000)\d){6,6}$)|(^[0][\d]{3}((?!000000)\d){6}$)|(^[3][\d]{3}((?!000000)\d){6}$)/;
    this.DIRECCION = /^([A-Za-z0-9\s-#ñÑ]{5,255})$/;
    this.TELCELULAR = /^[3][\d]{3}((?!000000)\d){6}$/;
    this.TELFIJO =
      /^(^[1-9]((?!000000)\d){6,6}$)|(^[0][\d]{3}((?!000000)\d){6}$)/;
    this.FICHA_SISBEN = /^([1-9][0-9]{0,7})$/;
    this.PORCENTAJE_PUNTAJE_SISBEN = /^[0-9]{0,9}$/;
    this.TIPO_DOCUMENTO_AS = /^\d{3,6}$|^\w{3,10}$/;
    this.TIPO_DOCUMENTO_MS = /^\d{3,6}$|^\w{3,12}$/;
    this.TIPO_DOCUMENTO_RC = /^\d{11}$|^[1]\d{9}$/;
    this.TIPO_DOCUMENTO_TI = /^\w{10}$|^\d{11}$/;
    this.TIPO_DOCUMENTO_CC = /^\d{3,8}$|^[1]\d{9}$/;
    this.TIPO_DOCUMENTO_CE = /^\w{3,6}$/;
    this.TIPO_DOCUMENTO_PA = /^\w{3,16}$/;
    this.TIPO_DOCUMENTO_CD = /^\w{9}$|^\w{11}$/;
    this.TIPO_DOCUMENTO_CN = /^\w{3,9}$/;
    this.TIPO_DOCUMENTO_SC = /^\w{3,9}$/;
    this.TIPO_DOCUMENTO_PE = /^\d{15}$/;
    this.NUMERO_PLANILLA = /^[0-9]{1,10}$/;
    this.SEGUNDO_APELLIDO =
      /^[a-zA-Z0-9áéíóúÁÉÍÓÚàèìòùÀÈÌÒÙñÑ."%'´`&=¨?^+[\]~{}¦^\s-_¢]{0,30}$/;
    this.PRIMER_APELLIDO =
      /^[a-zA-Z0-9áéíóúÁÉÍÓÚàèìòùÀÈÌÒÙñÑ."%'´`&=¨?^+[\]~{}¦^\s-_¢]{1,20}$/;
    this.PRIMER_NOMBRE =
      /^(?=.{1,20}$)([a-zA-Z0-9áéíóúÁÉÍÓÚàèìòùÀÈÌÒÙñÑ."%'´`&=¨?^+[\]~{}¦^\s-_¢]*?)*$/;
    this.SEGUNDO_NOMBRE =
      /^(?=.{1,30}$)([a-zA-Z0-9áéíóúÁÉÍÓÚàèìòùÀÈÌÒÙñÑ."%'´`&=¨?^+[\]~{}¦^\s-_¢]*?)*$/;
    this.PRIMER_NOMBRE_CONSULTA =
      /^(?=.{1,20}$)([a-zA-Z0-9áéíóúÁÉÍÓÚàèìòùÀÈÌÒÙñÑ."%'´`&=¨?^+[\]~{}¦^\s-_¢]*?)*$/;
    this.SEGUNDO_NOMBRE_CONSULTA =
      /^(?=.{1,30}$)([a-zA-Z0-9áéíóúÁÉÍÓÚàèìòùÀÈÌÒÙñÑ."%'´`&=¨?^+[\]~{}¦^\s-_¢]*?)*$/;

    /**
     * Validate:
     * -No spaces: (?!.*[\s])
     * -At least 1 uppercase character: (?=.*?[A-Z])
     * -At least 1 number: (?=.*?[0-9])
     * -At least 1 special character: (?=.*?\W)
     * -Min 8 characters lenght: (?=.{8,}$)
     */
    this.PORTAL_PASSWORD =
      /^(?!.*[\s])(?=.*?[A-Z])(?=.*?[0-9])(?=.*?\W)(?=.{8,}$).*$/;

    this.ONLY_TEXT_AND_NUMBER = /^[a-zA-Z0-9 ]+$/;
    this.ONLY_TEXT_AND_NUMBER_SPACE = /^[ña-zÑA-Z0-9 \-#.,]+$/;
    this.ONLY_NUMBERS = /^[0-9]*$/;
    this.URL =
      /^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/;
    // this.URL_CUSTOM = /^((([hH][tT][tT][pP][sS]?|[fF][tT][pP])\:\/\/)?([\w\.\-]+(\:[\w\.\&%\$\-]+)*@)?((([^\s\(\)\<\>\\\"\.\[\]\,@;:]+)(\.[^\s\(\)\<\>\\\"\.\[\]\,@;:]+)*(\.[a-zA-Z]{2,4}))|((([01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}([01]?\d{1,2}|2[0-4]\d|25[0-5])))(\b\:(6553[0-5]|655[0-2]\d|65[0-4]\d{2}|6[0-4]\d{3}|[1-5]\d{4}|[1-9]\d{0,3}|0)\b)?((\/[^\/][\w\.\,\?\'\\\/\+&%\$#\=~_\-@]*)*[^\.\,\?\"\'\(\)\[\]!;<>{}\s\x7F-\xFF])?)$/
    // this.URL_IP = /^((https?|http|ftp):\/\/)(\S+(:\S*)?@)?((?!10(\.\d{1,3}){3})(?!127(\.\d{1,3}){3})(?!169\.254(\.\d{1,3}){2})(?!192\.168(\.\d{1,3}){2})(?!172\.(1[6-9]|2\d|3[0-1])(\.\d{1,3}){2})([1-9]\d?|1\d\d|2[01]\d|22[0-3])(\.(1?\d{1,2}|2[0-4]\d|25[0-5])){2}(\.([1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(([_a-z\u{00a1}-\u{ffff}0-9]+-?)*[a-z\u{00a1}-\u{ffff}0-9]+)(\.([a-z\u{00a1}-\u{ffff}0-9]+-?)*[a-z\u{00a1}-\u{ffff}0-9]+)*(\.([a-z\u{00a1}-\u{ffff}]{2,})))(:\d{2,5})?(\/[^\s]*)?$/iu;

    this.DYNAMIC_KEY_PATTERN = /@\[[^\]]+\]\([^)]+\)/;
    this.DYNAMIC_KEY_PATTERN_GLOBAL = /@\[[^\]]+\]\([^)]+\)/g;
  }
}

const instance = new ExpresionesRegulares();

export default instance;
